export const IS_NOW = process.env.NEXT_PUBLIC_IS_NOW === 'true'
export const IS_SERVER = typeof window === 'undefined'
